import { ReactElement } from 'react';

import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
import { ArrowLeftIcon } from '../../icons/ArrowLeftIcon';
import {
  breadcrumbSteps,
  bussinessBreadcrumbSteps,
  GDFBreadcrumbSteps,
  FunctionaryBreadcrumbSteps,
} from '../data/breadcrumb';
import { useRouteLoaderData } from 'react-router-dom';

export function HirePlanMobileBreadcrumb(): ReactElement {
  const individualPlanData: any = useRouteLoaderData('token');
  const bussinessPlanData: any = useRouteLoaderData('token-empresa');
  const servidorPlanData: any = useRouteLoaderData('token-servidor');
  const servidorPlanDataCopy: any = useRouteLoaderData('token-servidorCopy');
  const functionaryPlanData: any = useRouteLoaderData('Empresa-token');
  let data = individualPlanData;
  if (individualPlanData != undefined) {
    data = individualPlanData;
  } else if (bussinessPlanData != undefined) {
    data = bussinessPlanData;
  } else if (servidorPlanDataCopy) {
    data = servidorPlanDataCopy;
  } else if (servidorPlanData) {
    data = servidorPlanData;
  } else {
    data = functionaryPlanData;
  }
  const step = useHirePlanFormStepStore(state => state.step);
  const goToPreviousStep = useHirePlanFormStepStore(
    state => state.goToPreviousStep,
  );
  console.log('arranjo final: ', data);

  const [currentStep] = data.type
    ? data.type == 'individual'
      ? breadcrumbSteps.filter(item => item.step === step)
      : data.type == 'bussiness'
      ? bussinessBreadcrumbSteps.filter(item => item.step === step)
      : GDFBreadcrumbSteps.filter(item => item.step === step)
    : FunctionaryBreadcrumbSteps.filter(item => item.step === step);

  return (
    <div className="w-full flex flex-col gap-11 mb-11">
      <div>
        <button onClick={goToPreviousStep} className="flex gap-2">
          <ArrowLeftIcon className="stroke-[#5C6770]" />
          <span className="text-[#5C6770] text-sm">
            Etapa {step} de {breadcrumbSteps.length}
          </span>
        </button>
      </div>
      <div className="flex flex-col items-center gap-1">
        <h2 className="text-xl text-primary-main font-bold">
          {currentStep.name}
        </h2>
        {currentStep.description && (
          <p className="text-secondary-main text-center mb-3">
            {currentStep.description}
          </p>
        )}
        <div className="h-1 w-[78px] bg-secondary-main" />
      </div>
    </div>
  );
}
